export default {
  SUCCESS: 'success',
  ERROR: 'error',
};
